import React from 'react';
import PropTypes from 'prop-types';

export default class SelectInput extends React.Component {
    // componentDidMount() {
    //     this.$sel = $(this.sel);
    //     this.$sel.customSelect();
    //     this.$sel.parent().eq(0).find('span').css('pointer-events', 'none');
    // }

    componentDidMount() {
        this.$sel = $(this.sel);
        this.$sel.customSelect();
        this.$sel.parent().eq(0).find('span').css('pointer-events', 'none');
        
        // Manually update the text content of the custom select
        const selectedValue = this.props.options.find(option => option.key === this.props.value);
        
        if (selectedValue) {
            this.$sel.parent().eq(0).find('.custom-select__trigger').text(selectedValue.value);
        }
    }
      

    componentDidUpdate(prevProps) {
        if (prevProps.value !== this.props.value) {
            // trigger a manual change event to make sure the value updates
            // if this was done in code (e.g. a state change from a different
            // field).
            const ele = document.getElementsByName(this.props.name)[0];
            const evt = document.createEvent('HTMLEvents');
            evt.initEvent('change', false, true);
            ele.dispatchEvent(evt);
        }

        // Some behaviour seems to cause the customSelect plugin to place a span
        // in front of our select element, and prevents pointer events from
        // triggering the drop down.
        //
        // Add some inline styles to prevent this from breaking.
        // refer to: https://app.asana.com/0/600006229086155/718242885066783/f
        this.$sel.parent().eq(0).find('span').css('pointer-events', 'none');
        this.$sel.trigger('render.customSelect');
    }

    render() {
        let inputClasses = 'select';
        if (this.props.required) {
            inputClasses += ' required';
        }
        if (typeof this.props.error !== 'undefined' && this.props.error !== '') {
            inputClasses += ' error';
        }
        let options = [];
        for (let i = 0; i < this.props.options.length; i++) {
            const option = this.props.options[i];
            options.push(<option value={option.key} key={option.key}>{option.value}</option>);
        }
       
        //if(this.props.value == "globals_au" || this.props.value == "globals_nz"){
        //    $(this.sel).attr("disabled","disabled");
        //}
        return (
            <label>
                <span className="sub-title text--grey">{this.props.label}</span>
                <div className="relative">
                    <select ref={sel => this.sel = sel} className={inputClasses}  name={this.props.name} value={this.props.value || "0"} onChange={(event) => this.props.onChange(event)} required={this.props.required}>
                        <option value="0" disabled>Please select</option>
                        {options}
                    </select>
                    <span className="error-indicator"></span>
                </div>
                {this.props.error && <span className="error text--red">{this.props.error}</span>}
            </label>
        )
    }
}

SelectInput.propTypes = {
    name: PropTypes.string.isRequired,
    label: PropTypes.string,
    value: PropTypes.string,
    error: PropTypes.string,
    required: PropTypes.bool,
    onChange: PropTypes.func,
};
